import React from "react";
import AppContent from "../components/AppContent";
// import { AppSidebar } from "../components/index";
import "./layout.scss";
import AppHeader from "../components/AppHeader";
import AppSidebar from "../components/AppSidebar";
import NoteState from "../../context/NOTES/NoteState";
import { useSelector } from "react-redux";

const DefaultLayout = () => {
  const sidebarShow = useSelector((state) => state.changeState.sidebarShow);
  console.log(sidebarShow, "sidebarShowsidebarShowsidebarShowsidebarShow");

  return (
    <div>
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeader />
        <AppSidebar />
        {/* <div className={sidebarShow ? "body flex-grow-1 px-3" : "content  px-3"}> */}
        <div
          className={
            sidebarShow ? "body flex-grow-1  cstm-bgmainall sidebarwidth" : " body flex-grow-1 cstm-bgmainall"
          }
        >
          <NoteState>
            <AppContent />
          </NoteState>
        </div>
        {/* <AppFooter /> */}
      </div>
    </div>
  );
};

export default DefaultLayout;
